import type { IconData } from '@stacksjs/iconify-core'

export const paragraph: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M440 64H208a128 128 0 0 0 0 256h56v128h112V96h64ZM264 288h-56a96 96 0 0 1 0-192h56Zm80 128h-48V96h48Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default paragraph
